import { useContext } from "react";
import FirstStepsContext from "Components/Organisms/FirstStepsProvider/FirstStepsContext";

export default function useFirstSteps() {
    const context = useContext(FirstStepsContext);

    if (!context) {
        throw new Error("useFirstSteps must be used within a FirstStepsProvider");
    }

    return context;
}